import { Injectable } from "@angular/core";
import { AppConfig } from "../configs/app";
import { CommonService } from "../services/common.service";
import { CacheService } from "../services/cache.service";

@Injectable({
  providedIn: "root",
})
export class AreaService {
  public _: any;

  constructor(
    public appConfig: AppConfig,
    public commonService: CommonService,
    public cacheService: CacheService
  ) {
    this._ = this.commonService.getLodash();
  }

  async getAreaDetails(queryParams: any) {
    let returnData = {};

    let params = {
      url: this.appConfig.busAPIBaseURL + "area/getAreaDetails",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
        params: queryParams,
      },
    };

    let returnedData = await this.commonService.sendHTTPGet(params);

    if (returnedData.status == "success") {
      returnData = returnedData.data;
    } else {
      console.log(returnedData.message);
    }

    return returnData;
  }
}
